module.exports = __webpack_public_path__ + "static/media/under-construction-banner.503bda44.jpg";